module.exports = __webpack_public_path__ + "static/media/statue.dc307559.png";